/* eslint-disable @typescript-eslint/no-empty-function */
import type { ModuleType } from 'i18next';

export class DocumentLanguageDetector {
    static type: ModuleType = 'languageDetector';

    init() {}

    cacheUserLanguage() {}

    detect() {
        switch (document.documentElement.lang.toLowerCase()) {
            case 'no':
            case 'nb-no':
                return 'no';

            case 'fi':
            case 'fi-fi':
                return 'fi';

            case 'se':
            case 'se-se':
            case 'sv-se':
                return 'se';
            default:
                return 'en';
        }
    }
}
